import { useState } from "react";

interface InfoData {
  text: string;    // Use string instead of any for better type safety
  lines?: number;  // Optional lines prop
}

const ReadMores: React.FC<InfoData> = ({ text, lines = 2 }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Approximate maxLength based on the number of lines (assuming ~50 characters per line)
  const maxLength = lines * 55;

  const toggleReadMore = () => {
    setIsExpanded((prev) => !prev);
  };

  if (text.length <= maxLength) {
    return <p>{text}</p>; // No Read More if text is short
  }

  return (
    <div>
      <p className="break-words">
        {isExpanded ? text : `${text.slice(0, maxLength)}...`}
        <button
          onClick={toggleReadMore}
          className="text-primary-color font-semibold  ml-2 focus:outline-none"
        >
          {isExpanded ? "Read Less" : "Read More"}
        </button>
      </p>
    </div>
  );
};

export default ReadMores;
